import React from "react";
import { Heading } from "../../components/ui/heading";
import { Text } from "../../components/ui/text";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";

const CustomerDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="p-6">
      <Heading className="mb-6">Customer Dashboard</Heading>
      <Text className="mb-4">Welcome, {user?.name || "Customer"}!</Text>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <Heading level={3} className="mb-4">
            My Calls
          </Heading>
          <Text className="mb-4">View your call history and details</Text>
          <Button onClick={() => navigate("/customer/calls")}>
            View Calls
          </Button>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <Heading level={3} className="mb-4">
            Reports
          </Heading>
          <Text className="mb-4">Access your call reports and analytics</Text>
          <Button onClick={() => navigate("/customer/reports")}>
            Call Reports
          </Button>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <Heading level={3} className="mb-4">
            Account Settings
          </Heading>
          <Text className="mb-4">Manage your account preferences</Text>
          <Button onClick={() => navigate("/customer/settings")}>
            Settings
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CustomerDashboard;
